import { Platform } from 'react-native';
import fs from 'react-native-fs';
const isAndroid = Platform.OS === 'android';

const app = {
  link: isAndroid ? 'https://play.google.com/store/apps/details?id=com.utilityxgitapp.sale.management' : 'itms-apps://itunes.apple.com/us/app/id1490758477?action=write-review',
  name: 'Sales Order Management',
  version: '1.0',
  patch: '1',
  devEmail: 'xgitdev@hotmail.com'
};

const imagePath = (Platform.OS === 'android' ? 'file://' : '') + `${fs.DocumentDirectoryPath}/realm_image_data/`;

const timeKey = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

const event = {};

const menuList = [];

const api = {};

export default {
  menuList,
  api,
  app,
  timeKey,
  event,
  imagePath,
  ORDER_STATUS: { PENDING: 0, COMPLETE: 1, CANCELED: 2 },
  ORDER_TYPE: {
    SALE: 0,
    IMPORT: 1,
    RETURN: 2,
    IMPORT_RETURN: 3,
    RECIEPT: 4, // Phiếu thu
    PAYMENT_VOUCHER: 5, // Phiếu chi
    DEBT: 6 // Phiếu nợ
  },
  ITEM_AMOUNT_TYPE: {
    SALE: 0,
    IMPORT: 1,
    RETURN: 2,
    UPDATE: 3,
    DELETE: 4, // 0 bán hàng, 1 nhập hàng, 2: Trả hàng, 3: Sửa kho, 4: Xóa đơn,
    TRANSFER: 5, //Chuyển kho
    GIFT: 6,
    IMPORT_RETURN: 7
  },
  SHOP_TYPE: {
    COUNTER: 0,
    GROCERY: 1,
    CAFE: 2,
    FASHION: 3,
    COSMETICS: 4,
    BABY: 5,
    BAKERY: 6,
    RESTAURENT: 7,
    BILLIARDS: 8,
    PHARMACY: 9,
    TOY: 10
  },
  PROMOTION_TYPES: {
    ORDER: 'order',
    PRODUCT: 'product',
    OGIFT: 'ogift',
    PGIFT: 'pgift'
  },
  languageList: [
    { code: 'en', flag: '🇬🇧', name: 'English' },
    { code: 'vi', flag: '🇻🇳', name: 'Tiếng Việt' },
    { code: 'lo', flag: '🇱🇦', name: 'ພາສາລາວ' },
    { code: 'my', flag: '🇲🇲', name: 'Myanmar' },
    { code: 'cn', flag: '🇨🇳', name: '中文' },
    { code: 'ja', flag: '🇯🇵', name: '日本人' },
    { code: 'ko', flag: '🇰🇷', name: '한국어' }
  ],
  PROMOTIONS: [
    { value: 0, type: 'order' },
    { value: 1, type: 'product' },
    { value: 2, type: 'ogift' },
    { value: 3, type: 'pgift' }
  ]
};
